export const CLIENT_ID_STORAGE_KEY = 'napi11es:client-id:v1';

export const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

/**
 * Returns the per-device UUID, generating one on first call. The UUID is
 * disclosed in the privacy policy and used solely for one-submission-per-day
 * dedupe (spec §4.2, §9 GDPR note).
 */
export function getOrCreateClientId(storage: Storage = localStorage): string {
  const existing = storage.getItem(CLIENT_ID_STORAGE_KEY);
  if (existing && UUID_V4_REGEX.test(existing)) {
    return existing;
  }
  const fresh = crypto.randomUUID();
  storage.setItem(CLIENT_ID_STORAGE_KEY, fresh);
  return fresh;
}
